import React from 'react';
import { Grid } from 'semantic-ui-react';

import MenuNavigationItem from './MenuNavigationItem';

export default ({ categories, displayCategoriesAs, showMenuNavigation, menuNavigationDivided }) =>
  showMenuNavigation && (
    <Grid
      divided={menuNavigationDivided}
      columns={categories.length}
      style={{ textAlign: 'center', marginBottom: '3em', marginLeft: '3em', marginRight: '3em' }}
      stackable
    >
      {categories.map(category => (
        <Grid.Column key={category}>
          <MenuNavigationItem category={category} displayCategoriesAs={displayCategoriesAs} />
        </Grid.Column>
      ))}
    </Grid>
  );
